/* * @Author: mikey.zhaopeng * @Date: 2025-05-07 13:27:54 * @Last Modified by:
mikey.zhaopeng * @Last Modified time: 2025-05-07 13:27:54 企业实名 */
<template>
  <div>
    <div class="mode1">
      <el-dialog :visible="mode1" @close="hideMode1" width="960px">
        <div class="mode1_content">
          <div class="button" @click="mode1Submit"></div>
        </div>
      </el-dialog>
    </div>
    <div class="mode2">
      <el-drawer :visible="mode2" direction="rtl" @close="hideMode2" :size="960" z-index="2000">
        <div slot="title">{{ title }}</div>
        <chaxun v-show="step === 'chaxun'" @chaxunjieguo="chaxunjieguo" />
        <chuangjian v-show="step === 'chuangjian'" :chaxunData="searchData" />
        <jiaru1 v-show="step === 'jiaru1'" :chaxunData="searchData" />
        <jiaru2 v-show="step === 'jiaru2'" :chaxunData="searchData" />
        <jiaru3 v-show="step === 'jiaru3'" :chaxunData="searchData" />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import chaxun from "./chaxun.vue";
import chuangjian from "./chuangjian.vue";
import jiaru1 from "./jiaru1.vue";
import jiaru2 from "./jiaru2.vue";
import jiaru3 from "./jiaru3.vue";
export default {
  components: {
    chaxun,
    chuangjian,
    jiaru1,
    jiaru2,
    jiaru3,
  },
  data() {
    return {
      searchData: {
        idNumber: "",
        name: "",
        representativeName: "",
        representativePhone: "",
        uuid: "",
        createdAt:0
      },
    };
  },
  created() {},
  computed: {
    ...mapState("qiyeshiming", ["mode1", "mode2", "step"]),
    ...mapGetters("qiyeshiming", ["title"]),
  },
  methods: {
    ...mapActions("qiyeshiming", ["showMode1", "showMode2", "hideMode1", "hideMode2"]),
    mode1Submit() {
      this.hideMode1();
      this.showMode2();
    },
    chaxunjieguo(data) {
      console.log(data)
      this.searchData = { ...this.searchData, ...data };
    },
  },
};
</script>

<style scoped lang="scss">
.mode1 {
  &_content {
    width: 960px;
    height: 414px;
    background-image: url(~@/assets/image/home/qiyeshiming/mode1.webp);
    background-size: 100%;
    position: relative;
    .button {
      width: 120px;
      height: 34px;
      position: absolute;
      bottom: 50px;
      left: 0;
      right: 0;
      margin: auto;
      cursor: pointer;
      border-radius: 4px;
      &:active {
        background: rgba($color: #000000, $alpha: 0.25);
      }
    }
  }
}
.mode2 {
  @include drawerStyle;
}
</style>
